import { Input } from "antd";
import { Select } from "antd";
import { Form } from "antd";
import { Col, Row } from "antd";
import React, { FC, useState } from "react";

type dischargeDetailsProps = {
  form: any;
  doctorTypeNameList: any;
  portalSubmission: any;
  isApproved: boolean;
};

const TreatingDoctorDetails: FC<dischargeDetailsProps> = ({ form, doctorTypeNameList, portalSubmission, isApproved }) => {
  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "18px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        Treating Doctor Details
      </div>
      <Form form={form} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="Doctor Type"
              name="treatingDoctorType"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please select doctor type",
                },
              ]}
            >
              <Select
                placeholder="Select doctor type"
                style={{ maxWidth: 300 }}
                disabled={portalSubmission}
              >
                {[{ label: "OTHERS", value: "O" }, { label: "SPECIALTY", value: "D" }]?.map((option) => (
                  <Select.Option key={option?.value} value={option?.value}>
                    {option?.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="Name"
              name="treatingDoctorName"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please select treating doctor name",
                },
              ]}
            >
              <Select
                placeholder="Select doctor name"
                style={{ maxWidth: 300 }}
                disabled={portalSubmission}
              >
                {doctorTypeNameList?.map((option: any) => (
                  <Select.Option key={option?.value} value={option?.docName +
                      "~" +
                      option?.docRegn +
                      "~" +
                      option?.docMobile +
                      "~" +
                      option?.docQualification}>
                    {option?.docName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="Regn No"
              name="treatingDoctorRegistrationNo"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please input treating Doctor Registration No",
                },
              ]}
            >
              <Input
                placeholder="Please input regn no"
                style={{ color: "black" }}
                disabled={true}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4} lg={4} xl={4}>
            <Form.Item
              label="Qualification"
              name="treatingDoctorQualification"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please input doctor qualification",
                },
              ]}
            >
              <Input
                placeholder="Please input qualification"
                style={{ color: "black" }}
                disabled={true}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={5} lg={5} xl={5}>
            <Form.Item
              label="Contact No"
              name="treatingDoctorContactNumber"
              style={{ color: "#575757" }}
            >
              <Input
                placeholder="Please input contact no"
                style={{ color: "black" }}
                disabled={true}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default TreatingDoctorDetails;
